import React, { Component } from 'react';

import RealizedPricesPreUpload from './RealizedPricesPreUpload';
import RealizedPricesSuccessUpload from './RealizedPricesSuccessUpload';

/**
 * This is the entry point for RealizedPrices. RealizedPrices has a few different states
 * depending on the user's actions.
 *
 * Prior to uploading a spreadsheet file, they will be in the "new" uploadState.
 * They will remain in this "new" uploadState until all upload errors are resolved.
 *
 * Once the spreadsheet successfully uploads - they will be moved into the "success"
 * uploadState where the user will no longer see the dropzone, and now
 * see the table of lots they have uploaded.
 */
class RealizedPrices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadState: 'new'
    };
  }

  // The upload was successful - move to the "success" state
  handleUpload = (lots, spreadsheetErrors, spreadsheetWarnings) => {
    this.setState({
      lots,
      spreadsheetErrors,
      spreadsheetWarnings,
      uploadState: 'success'
    });
  };

  // Reset the state back to 'new' so the user can upload a new spreadsheet
  goBackToUpload = () => {
    this.setState(
      {
        lots: null,
        uploadState: 'new'
      },
      () => {
        window.scrollTo(0, 0);
      }
    );
  };

  render() {
    const { lots, spreadsheetErrors, spreadsheetWarnings, uploadState } = this.state;

    if (uploadState === 'success') {
      return (
        <RealizedPricesSuccessUpload
          goBackToUpload={this.goBackToUpload}
          lots={lots}
          spreadsheetErrors={spreadsheetErrors}
          spreadsheetWarnings={spreadsheetWarnings}
          editType="realized"
        />
      );
    }

    return <RealizedPricesPreUpload handleUpload={this.handleUpload} />;
  }
}

export default (RealizedPrices);
